/**
 * Generate a random hexadecimal ID.
 *
 * - `length` = number of hex characters in the output (min 7).
 * - Uses `crypto.getRandomValues` when available, falls back to `Math.random`.
 */
export function uniqid(length = 17): string {
	const size = Math.max(7, Math.floor(length));

	// We generate bytes, then convert to hex and slice to the requested length.
	const byteCount = Math.ceil(size / 2);
	const bytes = new Uint8Array(byteCount);

	if (
		typeof crypto !== 'undefined' &&
		typeof crypto.getRandomValues === 'function'
	) {
		crypto.getRandomValues(bytes);
	} else {
		// Fallback for environments without crypto (older Node, tests, etc.)
		for (let i = 0; i < byteCount; i++) {
			bytes[i] = Math.floor(Math.random() * 256);
		}
	}

	let hex = '';
	for (let i = 0; i < byteCount; i++) {
		hex += bytes[i].toString(16).padStart(2, '0');
	}

	return hex.slice(0, size);
}
